const SCAN_PRODUCT = {
  title: 'Photo scanning',
  name: 'photo_scan',
};
const FILM_PRODUCT = {
  title: 'Film transfer',
  name: 'film_transfer',
};
const TAPE_PRODUCT = {
  title: 'Tape transfer',
  name: 'tape_transfer',
};
const AUDIO_PRODUCT = {
  title: 'Audio transfer',
  name: 'audio_transfer',
};

const DIGITAL_PRODUCT = {
  title: 'Device transfer',
  name: 'digital_transfer',
};

const BULLETS = [
  [
    {
      isCheckIcon: true,
      text: '6 Megapixel scan',
      [TAPE_PRODUCT.name]: 'Standard Color',
      [AUDIO_PRODUCT.name]: 'Unaltered From Original',
      [FILM_PRODUCT.name]: 'Standard Definition',
      [SCAN_PRODUCT.name]: 'Small File Size',
    },
    {
      isCheckIcon: true,
      text: 'No color correction',
      [TAPE_PRODUCT.name]: 'Standard Clarity',
      [AUDIO_PRODUCT.name]: 'Provided as Single Track',
      [FILM_PRODUCT.name]: 'Original Color & Tonality',
      [SCAN_PRODUCT.name]: 'No Color Correction',
    },
    {
      isCheckIcon: true,
      text: 'Original image clarity',
      [TAPE_PRODUCT.name]: 'Budget Friendly',
      [AUDIO_PRODUCT.name]: 'Basic Mastering',
      [FILM_PRODUCT.name]: 'Basic Reconditioning Included',
      [SCAN_PRODUCT.name]: 'Budget Friendly',
    },
    {
      isCheckIcon: true,
      text: 'No dust & scratch removal',
      [TAPE_PRODUCT.name]: 'Tape Cleaning Included',
      [AUDIO_PRODUCT.name]: 'Standard Fidelity Output',
      [FILM_PRODUCT.name]: 'Hand Processed by Pro Techs',
      [SCAN_PRODUCT.name]: 'Great for Sharing Online',
    },
  ],
  [
    {
      isCheckIcon: true,
      text: '12 Megapixel scan',
      [TAPE_PRODUCT.name]: 'HD Upscaled with AI Tools',
      [AUDIO_PRODUCT.name]: 'Optimized EQ and Dynamic Range',
      [FILM_PRODUCT.name]: '2k HD Upscaled',
      [SCAN_PRODUCT.name]: 'Ultra High Resolution Scans',
    },
    {
      isCheckIcon: true,
      text: 'Color correction',
      [TAPE_PRODUCT.name]: 'Color & Audio Correction',
      [AUDIO_PRODUCT.name]: 'Precise Track Editing',
      [FILM_PRODUCT.name]: 'High Dynamic Range Color',
      [SCAN_PRODUCT.name]: 'Industry-Best Color & Definition',
    },
    {
      isCheckIcon: true,
      text: 'Image clarity boost',
      [TAPE_PRODUCT.name]: 'Hand Optimized by Pro Techs',
      [AUDIO_PRODUCT.name]: 'Professional Noise Removal',
      [FILM_PRODUCT.name]: 'AI Based Visual Restoration',
      [SCAN_PRODUCT.name]: 'Contrast & Clarity Optimized',
    },
    {
      isCheckIcon: true,
      text: 'Minor dust & scratch removal',
      [TAPE_PRODUCT.name]: 'Engineered for HDTV Playback',
      [AUDIO_PRODUCT.name]: 'Available in Lossless Format',
      [FILM_PRODUCT.name]: 'Engineered for Modern HDTVs',
      [SCAN_PRODUCT.name]: 'Max Quality w/ AI Enhancement',
    },
  ],
  [
    {
      isCheckIcon: true,
      text: '12 Megapixel scan',
      [TAPE_PRODUCT.name]: 'HD Upscaled with AI Tools',
      [AUDIO_PRODUCT.name]: 'Optimized EQ and Dynamic Range',
      [FILM_PRODUCT.name]: '2k HD Upscaled',
      [SCAN_PRODUCT.name]: 'Ultra High Resolution Scans',
    },
    {
      isCheckIcon: true,
      text: 'Color correction',
      [TAPE_PRODUCT.name]: 'Color & Audio Correction',
      [AUDIO_PRODUCT.name]: 'Precise Track Editing',
      [FILM_PRODUCT.name]: 'High Dynamic Range Color',
      [SCAN_PRODUCT.name]: 'Industry-Best Color & Definition',
    },
    {
      isCheckIcon: true,
      text: 'Image clarity boost',
      [TAPE_PRODUCT.name]: 'Hand Optimized by Pro Techs',
      [AUDIO_PRODUCT.name]: 'Professional Noise Removal',
      [FILM_PRODUCT.name]: 'AI Based Visual Restoration',
      [SCAN_PRODUCT.name]: 'Contrast & Clarity Optimized',
    },
    {
      isCheckIcon: true,
      text: 'Minor dust & scratch removal',
      [TAPE_PRODUCT.name]: 'Engineered for HDTV Playback',
      [AUDIO_PRODUCT.name]: 'Available in Lossless Format',
      [FILM_PRODUCT.name]: 'Engineered for Modern HDTVs',
      [SCAN_PRODUCT.name]: 'Max Quality w/ AI Enhancement',
    },
  ],
];

export {
  BULLETS,
  SCAN_PRODUCT,
  FILM_PRODUCT,
  TAPE_PRODUCT,
  AUDIO_PRODUCT,
  DIGITAL_PRODUCT,
};
